import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {EventService} from "../../../../service/api/event.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../model/response/ApiResponse";

@Component({
    selector: 'app-event-remove-reason-modal',
    templateUrl: './event-remove-reason-modal.component.html',
    standalone: false
})
export class EventRemoveReasonModalComponent {
  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean

  @Output('onCloseSuccess') onCloseSuccess = new EventEmitter<EventResponse>()
  @Output('onCancelModal') onCancelModal = new EventEmitter<any>()

  isLoading = false;

  constructor(
    private eventService: EventService,
    private messageToast: MessageToastService,
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.isLoading = true
    this.apiDeleteEvent()
  }

  apiDeleteEvent() {
    this.eventService.restoreToRemoveEvent(this.event.id).pipe(
      finalize(() => this.isLoading = false),
      tap({
        next: value => {
          this.messageToast.success(value.message)
          this.onCloseSuccess.emit(value.data)
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<any>) => this.messageToast.error(err?.message)
      })).subscribe()
  }
}
